<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Oliver F Browne Snr is one of six children, an identical twin who grew up in a small village in Tipperary, Ireland. He is married to Carmel and a father of two boys. Oliver, aged nine, is the children’s book author <em>of A Cat and Eight Kittens and Gerard</em>, aged eight. As well as writing, he is an avid mountain climber and underage rugby coach at his favourite club, Kilfeacle RFC.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?795a0391